/* eslint-disable max-lines */

import { PencilSquareIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import usePageIndex from "../../hooks/usePageIndex";
import { useSearch } from "../../hooks/useSearch";
import {
  deleteBlockedUser,
  getAllBlockedUsers
} from "../../services/BlockedUser.service";
import IconBtn from "../ui/IconBtn";
import Table, { Row } from "../ui/table";
import DeleteBlockedUser from "./DeleteBlockedUserModal";

const columns: (string | number)[] = [
  "Email",
  "Block eSIM NLB",
  "Block eSIM Stripe",
  "Block Journey NLB",
  "Block Journey Stripe",
  "Block All",
  "Arsyeja",
  "Data e krijimit",
  "Data e përditësimit",
  "Veprimet"
];

const BlockedUsers = () => {
  const { response, loading, setResponse } = useSearch(
    getAllBlockedUsers,
    {
      withQuerySearch: true
    }
  );
  const { pageIndex, state }: any = usePageIndex();

  const handleDelete = (id: number) => {
    deleteBlockedUser(id)
      .then(() => {
        toast.success("Përdoruesi është hequr nga lista e zezë me sukses.", {
          position: "top-right"
        });
        setResponse((prev) =>
          prev
            ? {
                ...prev,
                data: prev.data.filter((el) => el.id !== id)
              }
            : null
        );
      })
      .catch(() => toast.error("Ndodhi një gabim gjatë fshirjes."));
  };

  const renderCheckmark = (value: boolean) => (
    <span className={value ? "text-green-600" : "text-red-600"}>
      {value ? "✓" : "✗"}
    </span>
  );

  return (
    <div className="flex flex-col" style={{ height: "calc(100vh - 11rem)" }}>
      <Table
        titles={columns}
        loading={loading}
        className="overflow-x-auto"
        style="hover"
      >
        {response?.data?.length ? (
          response?.data?.map((row, i: number) => {
            const highlighted = +state?.params?.id === row.id;
            return (
              <Row
                key={i}
                className={`${highlighted && "highlighted"}`}
                email={row.email}
                blockEsimReservationNlb={renderCheckmark(
                  row.blockEsimReservationNlb
                )}
                blockEsimReservationStripe={renderCheckmark(
                  row.blockEsimReservationStripe
                )}
                blockJourneyReservationNlb={renderCheckmark(
                  row.blockJourneyReservationNlb
                )}
                blockJourneyReservationStripe={renderCheckmark(
                  row.blockJourneyReservationStripe
                )}
                blockAll={renderCheckmark(row.blockAll)}
                blockReason={row.blockReason || "-"}
                insertDate={
                  row.insertDate
                    ? dayjs(row.insertDate).format("DD-MM-YY")
                    : "-"
                }
                updateDate={
                  row.updateDate
                    ? dayjs(row.updateDate).format("DD-MM-YY")
                    : "-"
                }
                actions={
                  <span className="flex items-center">
                    <Link
                      to={`/blocked-users/edit/${row.id}`}
                      state={{
                        crumbs: ["Blocked Users", "Modifiko përdoruesin"],
                        page: pageIndex,
                        userData: row
                      }}
                    >
                      <IconBtn className="w-6 h-6">
                        <PencilSquareIcon className="w-4 h-4" />
                      </IconBtn>
                    </Link>
                    <DeleteBlockedUser
                      handleDelete={() => handleDelete(row.id!)}
                    />
                  </span>
                }
              />
            );
          })
        ) : (
          <></>
        )}
      </Table>
    </div>
  );
};

export default BlockedUsers;
